<template>
    <v-card flat>
        <v-card-title primary-title>
            <h3 class="subheading font-weight-regular mb-1 section-title--color">Filter</h3>
        </v-card-title>
        <v-card-text class="pa-0 px-3">
            <v-radio-group
                    :mandatory="false"
                    @change="postFilter"
                    class="mt-0 custom-radio-size"
                    v-model="postStatus"
            >
                <v-radio
                        :ripple="false"
                        v-bind="{value}"
                        color="bindezcolor"
                        v-for="{value, text} in options"
                        :key="text"
                >
                    <template slot="label">
                        <div class="d-flex align-center" style="width: 100%">
                            <span
                                    class="body-2 font-weight-regular text-capitalize"
                                    style="color:#777777; margin-left: -5px"
                            >
                                {{text}}
                            </span>
                            <div class="text-xs-right">
                                <v-tooltip top>
                                    <template slot="activator" slot-scope="{on}">
                                        <v-chip activator v-on="on" color="bindezcolor" small label text-color="#fff">
                                            {{statusCount[text] | abbrNumber}}
                                        </v-chip>
                                    </template>
                                    <span>{{statusCount[text] | formatNumber}}</span>
                                </v-tooltip>
                            </div>
                        </div>
                    </template>
                </v-radio>
            </v-radio-group>
        </v-card-text>
    </v-card>
</template>

<script>
	import {mapState, mapMutations} from 'vuex';

	export default {
		name: "PostFilter",
		data() {
			return {
				options: [
					{value: null, text: "all"},
					{value: true, text: "watched"},
					{value: false, text: "unwatched"}
				]
			}
		},
		computed: {
			...mapState({
				watchedCount: state => state.facebookSummary.posts_count.watch_count,
				unwatchedCount: state => state.facebookSummary.posts_count.unwatch_count
			}),

			...mapState('mention', [
				"status"
			]),

			statusCount() {
				let all = this.watchedCount + this.unwatchedCount;
				return {
					all,
					watched: this.watchedCount,
					unwatched: this.unwatchedCount,
				}
			},

			postStatus: {
				get() {
					return this.status
				}, set(status) {
					this.setPostStatus(status)
				}
			}
		},
		methods: {
			...mapMutations('mention', [
				"setPostStatus"
			]),

			postFilter() {
				this.$ua.trackEvent("Filter Post", "check", "Filter By Status");
				this.$emit('postFilter');
			}
		}
	}
</script>

<style scoped>
    .custom-radio-size >>> .v-input__control, .custom-radio-size >>> .v-label {
        width: 100%;
    }

    .custom-radio-size >>> .v-radio{
        margin-right: 0
    }
</style>
